import { useQuery } from '@apollo/client';
import { usePaginationSearch, useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import { PAGINATED_SIZE } from '../constants';
import { useSearch } from '../useSearch';
import { useBreederOrderBuilder } from './useBreederOrderBuilder';
import { useBreedersWhereBuilder } from './useBreederWhereBuilder';

export const BREEDER_LIST_GET_BREEDERS = graphql(`
  query BreederListGetBreeders(
    $where: DogBreederWhereInput
    $orderBy: [DogBreederOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $skip: Int
    $breederCardInfoTranslationsWhere: DogBreederTranslationWhereInput
    $breederCardInfoTranslationsWhereBreed: DogBreedTranslationWhereInput
    $breederCardInfoLittersWhere: LitterWhereInput
    $breederCardInfoBreedImgsTake: Int
  ) {
    findManyDogBreeder(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      ...BreederCardInfo
    }
    aggregateDogBreeder(where: $where) {
      _count {
        _all
      }
    }
  }
`);

export const useGetBreeders = () => {
  const { language } = useRouter();
  const { valuesFromSearch } = useSearch();
  const { breedersWhereBuilder } = useBreedersWhereBuilder();
  const { breederOrderBuilder } = useBreederOrderBuilder();
  const { currentPage } = usePaginationSearch();

  const { data, error, loading, fetchMore, refetch } = useQuery(BREEDER_LIST_GET_BREEDERS, {
    variables: {
      take: PAGINATED_SIZE,
      skip: PAGINATED_SIZE * currentPage,
      where: breedersWhereBuilder(valuesFromSearch),
      orderBy: breederOrderBuilder(),
      breederCardInfoTranslationsWhere: { language: { equals: language } },
      breederCardInfoTranslationsWhereBreed: { language: { equals: language } },
      breederCardInfoBreedImgsTake: 1,
      breederCardInfoLittersWhere: {
        archived: { equals: false },
        adminValidated: { equals: true },
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  return {
    breeders: data?.findManyDogBreeder ?? [],
    // eslint-disable-next-line no-underscore-dangle
    breedersCount: data?.aggregateDogBreeder?._count?._all ?? 0,
    breedersError: error,
    breedersLoading: loading,
    breedersFetchMore: fetchMore,
    breedersRefetch: refetch,
  };
};
